import getPatientZip from 'utils/print/getPatientZip';

const getInsuranceInsuredsZip = ({ value, ...otherProps }) => {
  if (value !== null && value !== undefined) {
    return value;
  }
  return getPatientZip(otherProps);
};

export default getInsuranceInsuredsZip;



// WEBPACK FOOTER //
// ./src/utils/print/getInsuranceInsuredsZip.js